import CMRLanding from '@/views/landing/CommonLanding';

export default [
    {
        path: '/cmr/landing',
        name: 'cmrlanding',
        component: CMRLanding,
        meta: { layout: 'landing', accessedby: 'CAM' }
    },
];